<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <RedirectBack></RedirectBack>
        <span v-if="route.name == 'socialPageEdit'">Editar rede social</span>
        <span v-else>Nova rede social</span>
      </h1>
      <div>
        <PrimaryButton @click="submit()" class="px-5" icon="fa-solid fa-floppy-disk">Salvar</PrimaryButton>
      </div>
    </div>
  </div>

  <div class="align p-4 space_title">
    <div v-if="!loading" class="card">
      <div class="p-4">
        <form>
          <div class="row">
            <div class="col-12 mb-3">
              <InputText label="Nome" v-model="page.name" :error="formErrors.name" />
            </div>

            <div class="col-12 mb-3">
              <InputText label="Link" v-model="page.url" :error="formErrors.url" />
            </div>

            <div class="col-12 mb-3">
              <InputText type="number" label="Ordem de exibição" v-model="page.ordenation" :error="formErrors.ordenation" />
            </div>

            <div class="col-12 mb-3">
              <SelectBox
                id="status"
                label="Status"
                placeholder="Selecione"
                :items="statuses"
                v-model="page.status"
                :error="formErrors.status"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
  
<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import InputText from '@/components/InputText.vue'
import RedirectBack from '@/components/RedirectBack.vue'
import { useSocialStore } from '@/stores/SocialStore'
import { inject, onMounted, ref } from 'vue';
import { useToast, TYPE } from "vue-toastification";
import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import SelectBox from '@/components/SelectBox.vue';
import {errorFormat} from "@/utils/errorFormat";
const toast = useToast();

const loader = inject('$loader');
const loading = ref(true);

const formErrors = ref({});

const socialStore = useSocialStore();
const { page } = storeToRefs(socialStore);

const route = useRoute();
const router = useRouter();

const statuses = ref([
  { id: '1', name: 'Ativada' },
  { id: '0', name: 'Desativada' },
]);

onMounted(async () => {
  socialStore.page = {};


  const id = route.params.id;
  if(id){
    loader.show();
    await socialStore.getPage(id);
    loader.hide();
  }

  loading.value = false;
});

const submit = async() => {
    let params = ref({
      name: socialStore.page.name,
      url: socialStore.page.url,
      ordenation: socialStore.page.ordenation,
      status: socialStore.page.status,
    });

    loader.show();
    formErrors.value = {};

    if(socialStore.page.id){
      const formResult = await socialStore.updatePage(socialStore.page.id, params.value);
      if(formResult.success){
        toast('Rede social atualizada', { type: TYPE.SUCCESS, timeout: 6000 });
      }
      else {
        formErrors.value = errorFormat(formResult.errors);
      }
    }
    else {
      const formResult = await socialStore.addPage(params.value);
      if(formResult.success){
        toast('Rede social criada', { type: TYPE.SUCCESS, timeout: 6000 });
        router.push({ name: 'socialPages'});
      }
      else {
        formErrors.value = errorFormat(formResult.errors);
      }
    }

    loader.hide();
};
</script>

<style scoped>
.image_upload {
  height: 150px;
  background-color: #ebebeb;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
}

.image_upload:hover {
  background-color: #d7d7d7;
}

.image_upload h4 {
  font-size: 18px;
  margin-bottom: 0;
}

.image_upload span {
  font-size: 14px;
  font-weight: 600;
  color: #7f7f7f;
}
</style>